const AncillariesCalculator = require('./ancillaries.calculator');

module.exports = new AncillariesCalculator();
